module.exports = __webpack_public_path__ + "static/img/clients-icon-28.5b4c7d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clients-icon-28.png
// module id = 69
// module chunks = 0